var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "796 796 200 200",
    enableBackground: "new 796 796 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M956.23,854.952v-43.796c0-8.357-6.801-15.156-15.158-15.156h-90.144c-8.358,0-15.158,6.799-15.158,15.156v43.796 c0,27.8,18.936,51.245,44.585,58.151c4.833,1.301,8.201,5.685,8.201,10.689v46.241c0,6.117-4.96,11.077-11.078,11.077h-30.204 c-4.11,0-7.444,3.334-7.444,7.444s3.333,7.444,7.444,7.444h97.45c4.111,0,7.445-3.334,7.445-7.444s-3.334-7.444-7.445-7.444h-30.203 c-6.117,0-11.077-4.96-11.077-11.077v-46.241c0-5.013,3.36-9.387,8.2-10.689C937.294,906.198,956.23,882.752,956.23,854.952z  M850.659,854.952v-43.795c0-0.148,0.122-0.269,0.27-0.269h90.144c0.148,0,0.27,0.12,0.27,0.269v43.795 c0,25.001-20.34,45.342-45.341,45.342S850.659,879.954,850.659,854.952z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.406ba3c095b4abf87f8b9756307aac25.svg";
export { ForwardRef as ReactComponent };